/* GH-1133 S5 — S10 (design §2.2, §2.4): the lock card for a route the free
   preview does not open. A copy of PostingFeatureLock (same posting-lock__*
   styles, no new design system) with the trial CTA opening the wall and a
   way back to the drafts. */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../Icons.jsx';
import MarketingSubnav from '../MarketingSubnav.jsx';
import { useFreePreview } from '../../contexts/FreePreviewContext.jsx';
import { previewFeatureLabelKey } from '../../lib/previewAccess.js';
import { trackPreview } from '../../lib/freePreviewEvents.js';

export default function PreviewFeatureLock({ feature = 'other', source = 'feature' }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const freePreview = useFreePreview();
  const labelKey = previewFeatureLabelKey(feature);
  const label = t(labelKey);

  useEffect(() => { trackPreview('preview_locked_route_viewed', { feature }); }, [feature]);

  return (
    <div className="posting-lock fp-lock">
      {(feature === 'plan' || feature === 'strategy') && <MarketingSubnav />}
      <div className="posting-lock__preview" aria-hidden="true">
        <span className="posting-lock__line posting-lock__line--title" />
        <span className="posting-lock__line" />
        <span className="posting-lock__line posting-lock__line--short" />
        <div className="posting-lock__grid"><span /><span /><span /></div>
      </div>
      <section className="posting-lock__card" aria-labelledby="preview-lock-title">
        <span className="posting-lock__icon"><Icon name="lock" size={20} /></span>
        <div>
          <p className="posting-lock__eyebrow">{t('freePreview.eyebrow')}</p>
          <h1 id="preview-lock-title">{t('freePreview.lockTitle', { feature: label })}</h1>
          <p>{t('freePreview.lockBody')}</p>
          <div className="fp-lock-actions">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => freePreview.openTrialWall(source, { feature, featureLabelKey: labelKey })}
            >
              {t('freePreview.trialCta')}
            </button>
            <button type="button" className="btn btn-ghost" onClick={() => navigate('/app')}>
              {t('freePreview.wallBack')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
